import Moon from '../../src/legacy/Moon';
export default Moon;
